<script setup>
import SectionHero from '@/components/SectionHero.vue';

import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3';

import {useRouting} from "@/composables/routing.js";
import SectionHalfText from "@/components/SectionHalfText.vue";
import SectionTextWithFlatCards from "@/components/SectionTextWithFlatCards.vue";
import SectionSimpleText from "@/components/SectionSimpleText.vue";
import SectionLinklist from "@/components/SectionLinklist.vue";
import DomainPricingTable from "@/components/DomainPricingTable.vue";
const {href, url} = useRouting();

const props = defineProps({
    content: {
        type: Array,
        required: true
    },
    tld: {
        type: String,
        required: true
    },
    domainPricing: {}
})
</script>

<template>
    <Head>
        <title>Domains einfach registrieren</title>
        <meta name="description" content="Einfache Registrierung und Verwaltung in der LAY7 cloud">
        <link rel="canonical" :href="url('/domains', 'de')">
        <link rel="alternate" hreflang="en" :href="url('/domains', 'en')">
        <link rel="alternate" hreflang="de" :href="url('/domains', 'de')">
    </Head>
    <div>
        <section-hero title="Domains"
                      subtitle="Einfache Registrierung und Verwaltung in der LAY7 cloud"
        />

        <template v-for="module in content">
            <section-half-text v-if="module.type === 'section-half-text'"
                               v-bind="module.data"
            />
            <section-text-with-flat-cards v-if="module.type === 'section-text-with-flat-cards'"
                                          v-bind="module.data"
            />
            <section-simple-text v-if="module.type === 'simple-text'"
                                 v-bind="module.data"
            />
            <section-linklist v-if="module.type === 'section-linklist'"
                              v-bind="module.data"
            />
        </template>

        <section class="mt-24 lg:mt-36" id="domains">
            <div class="container px-4 mx-auto">
                <h2 class="font-semibold text-4xl text-black space-x-3 mb-2">
                    Preise für Domain-Registrierungen
                </h2>

                <div>
                    <p class="text-lg max-w-[60rem]">
                        Die LAY7 Cloud bietet Ihnen transparente und faire Preise für Domain-Registrierungen.
                        Unsere Preisstruktur ist so gestaltet, dass Sie nicht nur den besten Service,
                        sondern auch einen optimalen Preis erhalten. Nachfolgend finden Sie eine Übersicht der Domain-Preise:
                    </p>

                    <domain-pricing-table :domainPricing="domainPricing" />
                </div>
            </div>
        </section>
    </div>
</template>
